// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/CourierModal/pages/styles/CheckPage.module.css */

.CheckPage_container__P9ZVB {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background-color: #fff;
  overflow-y: auto;
}

.CheckPage_heading__81CPQ {
  margin: 0 0 16px;
  font-size: 1.25rem;
  color: #333;
}

.CheckPage_list__ityoY {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
}

.CheckPage_listItem__lzMZp {
  margin-bottom: 8px;
  font-size: 1rem;
  color: #555;
}

.CheckPage_productList__G0wfH {
  margin-bottom: 16px;
}

.CheckPage_subheading__BEb7r {
  margin: 0 0 8px;
  font-size: 1.1rem;
}

.CheckPage_productItem__VDES2 {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.CheckPage_productName__IuMxt {
  font-weight: 500;
  color: #333;
}

.CheckPage_marks__8b-ep {
  color: #666;
}

/* Секция действий: сразу после контента */
.CheckPage_actions__CeMe1 {
  display: flex;
  flex-direction: column;
  gap: 12px;       /* расстояние между кнопками */
  width: 100%;
  margin-top: 16px; /* небольшой отступ сверху */
}

.CheckPage_button__qDAtG {
  width: 100%;
  padding: 12px;
  font-size: 1rem;
  text-align: center;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-sizing: border-box;
}

.CheckPage_button__qDAtG:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  /* если нужно, чтобы клики совсем игнорировались */
  pointer-events: none;
}

.CheckPage_button__qDAtG:hover {
  background-color: #0056b3;
}

.CheckPage_button__qDAtG:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/CheckPage.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,QAAQ,8BAA8B;EAC/C,WAAW;EACX,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["/* src/modules/Courier/pages/CourierModal/pages/styles/CheckPage.module.css */\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 16px;\r\n  box-sizing: border-box;\r\n  background-color: #fff;\r\n  overflow-y: auto;\r\n}\r\n\r\n.heading {\r\n  margin: 0 0 16px;\r\n  font-size: 1.25rem;\r\n  color: #333;\r\n}\r\n\r\n.list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 16px;\r\n}\r\n\r\n.listItem {\r\n  margin-bottom: 8px;\r\n  font-size: 1rem;\r\n  color: #555;\r\n}\r\n\r\n.productList {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.subheading {\r\n  margin: 0 0 8px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.productItem {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 8px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.productName {\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.marks {\r\n  color: #666;\r\n}\r\n\r\n/* Секция действий: сразу после контента */\r\n.actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;       /* расстояние между кнопками */\r\n  width: 100%;\r\n  margin-top: 16px; /* небольшой отступ сверху */\r\n}\r\n\r\n.button {\r\n  width: 100%;\r\n  padding: 12px;\r\n  font-size: 1rem;\r\n  text-align: center;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  /* если нужно, чтобы клики совсем игнорировались */\r\n  pointer-events: none;\r\n}\r\n\r\n.button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.button:disabled {\r\n  background-color: #aaa;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CheckPage_container__P9ZVB`,
	"heading": `CheckPage_heading__81CPQ`,
	"list": `CheckPage_list__ityoY`,
	"listItem": `CheckPage_listItem__lzMZp`,
	"productList": `CheckPage_productList__G0wfH`,
	"subheading": `CheckPage_subheading__BEb7r`,
	"productItem": `CheckPage_productItem__VDES2`,
	"productName": `CheckPage_productName__IuMxt`,
	"marks": `CheckPage_marks__8b-ep`,
	"actions": `CheckPage_actions__CeMe1`,
	"button": `CheckPage_button__qDAtG`
};
export default ___CSS_LOADER_EXPORT___;
